import { PermissionRequirement } from './permission.model';

export const COMPANY_SETTINGS_PERMISSIONS = {
  show: { resource: 'companies', action: 'show' },
  update: { resource: 'companies', action: 'update' },
} as const satisfies Record<string, PermissionRequirement>;

/** Permisos tenant resource `locations` (sedes, paridad Rails). */
export const SETTINGS_LOCATION_PERMISSIONS = {
  list: { resource: 'locations', action: 'index' },
  show: { resource: 'locations', action: 'show' },
  create: { resource: 'locations', action: 'create' },
  update: { resource: 'locations', action: 'update' },
} as const satisfies Record<string, PermissionRequirement>;
